import React from "react";
import { Helmet } from "react-helmet";
import Services from "../../components/services/Services";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";

function ServicesPage({ setShow }) {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>Services | GGAS</title>
        <meta name="keyword" content="GGAS" />
        <meta name="description" content="GGAS" />
      </Helmet>
      <Breadcrumb title={"Our Services"} t={t} />
      <Services />
    </>
  );
}

export default ServicesPage;
